import React from "react";
import AWS from "aws-sdk";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { HttpRequest } from "@smithy/protocol-http";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { Hash } from "@smithy/hash-node";
import { ChangeEvent, ChangeEventHandler, SetStateAction, useState } from "react";
import { createPresignedPost } from "@aws-sdk/s3-presigned-post";
import FormDataLib from "form-data";
import { Box, Dialog } from "@mui/material";
import { SettingsPowerRounded } from "@mui/icons-material";
import config from "../amplifyconfiguration.json";
import { SQW_Log, DebugLevel } from "services/Logging";
import { GetAWSCredentials } from "services/GetInvoiceData";

const S3_BUCKET = config.aws_image_bucket_name;
const REGION = config.aws_cognito_region;


const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
});

type Props = {
    setURL: (url: string) => void;
    open: boolean;
    setOpen: (open: boolean) => void;
    tenantId: string;
    directory?: string;
};

const UploadFile: React.FC<Props> = ({ setURL, open, setOpen, tenantId, directory }) => {
    const [progress, setProgress] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null as any);
    const [isOpen, setIsOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleFileInput = (e: any) => {
        setSelectedFile(e.target.files[0]);
    };

    function generateUUID() {
        // Public Domain/MIT
        var d = new Date().getTime(); //Timestamp
        var d2 =
            (typeof performance !== "undefined" && performance.now && performance.now() * 1000) ||
            0; //Time in microseconds since page-load or 0 if unsupported
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = Math.random() * 16; //random number between 0 and 16
            if (d > 0) {
                //Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                //Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        });
    }

    const uploadFile = async (file: any, setURL: (url: string) => void) => {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        var fileName =
            (directory ? directory + "/" : "") +
            (tenantId === "" ? "" : tenantId + "/") +
            generateUUID() +
            "." +
            fileExtension

        fileName = fileName.toLowerCase();

        const params = {
            ACL: "public-read" as const,    
            Body: file,
            Bucket: S3_BUCKET,
            Key: fileName,
        };

        SQW_Log(DebugLevel.LOG, "params: ", params);

        /*myBucket
            .putObject(params)
            .on("httpUploadProgress", (evt: any) => {
                setProgress(Math.round((evt.loaded / evt.total) * 100));
            })
            .send((err: any, data: any) => {
                if (err) SQW_Log(DebugLevel.LOG, err);
                else SQW_Log(DebugLevel.LOG, "Success", data);
            }).promise().then(() => {
                
            });
*/

        const credentials = await GetAWSCredentials();

        if (credentials != null) {
            const s3 = new S3Client({
                region: config.aws_cognito_region,
                credentials
            });

            const command = new PutObjectCommand(params);

            s3.send(command).then(() => {
                const url = `https://${S3_BUCKET.toLowerCase()}.s3.${REGION.toLowerCase()}.amazonaws.com/${fileName}`;
                SQW_Log(DebugLevel.LOG, "File uploaded successfully at URL: ", url);
                setURL(url.toLowerCase());
                alert("File uploaded successfully");
                setOpen(false);
            }).catch((err) => {
                SQW_Log(DebugLevel.ERROR, "Error uploading file: ", err);
                alert("Error uploading file: " + err.message);
            });
        } else {
            SQW_Log(DebugLevel.ERROR, "No AWS credentials available for S3 upload.");
            alert("No AWS credentials available for upload.");
        }
        
    }

    const setToBlank = () => {
        setURL("");
        setOpen(false);
    }

        
            // If credentials is a CognitoIdentityCredentialProvider, extract the underlying credentials
        
       /* myBucket
            .upload(params)
            .on("httpUploadProgress", (evt: any) => {
                setProgress(Math.round((evt.loaded / evt.total) * 100));
            })
            .promise()
            .then((data: any) => {
                SQW_Log(DebugLevel.LOG, data.Location);
                setURL(data.Location.toLowerCase());
                alert("File uploaded successfully");
            })
            .catch((err: any) => SQW_Log(DebugLevel.LOG, err));
        setOpen(false);
    };*/

    return (
        <Dialog open={open}>
            <Box m='30px'>
                {/* <div>Upload Progress: {progress}%</div> */}
                <input
                    type='file'
                    onChange={handleFileInput}
                    title="Select a file to upload"
                    placeholder="Choose file"
                />
                <br />
                <br />
                <button style={{display: "inline-block", marginRight: "10px"}} onClick={() => uploadFile(selectedFile, setURL)}>Upload File</button>
                <button style={{display: "inline-block", marginRight: "10px"}} onClick={() => setToBlank()}>Set To Blank</button>
                <button style={{display: "inline-block"}} onClick={() => setOpen(false)}>Cancel</button>
            </Box>
        </Dialog>
    );
};

export default UploadFile;
